import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2aed5e84"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["simply-fade"];
const _hoisted_2 = ["href"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'arrow_link',
    props: {
        link: String,
        text: String,
        small: {
            type: Boolean,
            default: false
        },
        centreAlign: {
            type: Boolean,
            default: false
        },
        hasAnimation: {
            type: Boolean,
            default: true
        }
    },
    setup(__props) {
        const props = __props;
        const cta = ref();
        function ctaClicked() {
            cta.value.classList.add('clicked');
        }
        function isLastArrowLink() {
            // Check if this instance is the last <arrow-link> in the parent container
            const parent = this.$el.parentElement;
            const arrowLinks = parent ? parent.querySelectorAll('.arrow-link') : [];
            return arrowLinks.length > 0 && arrowLinks[arrowLinks.length - 1] === this.$el;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "simply-fade": __props.hasAnimation ? 'right' : undefined
            }, [
                _createElementVNode("a", {
                    href: props.link,
                    onClick: ctaClicked,
                    ref_key: "cta",
                    ref: cta,
                    class: _normalizeClass(`arrow-link ${isLastArrowLink ? 'mb-4' : ''} ${__props.centreAlign ? 'centre' : ''} ${__props.small ? 'small' : ''}`)
                }, _toDisplayString(props.text), 11, _hoisted_2)
            ], 8, _hoisted_1));
        };
    }
});
